class ClientType {
    static WEB_CLIENT = 'WEB_CLIENT';
    static WS_CLIENT = 'WS_CLIENT';
    static GQL_CLIENT = 'GQL_CLIENT';
}
export default ClientType;
